import Request from '@/utils/request'

// 9.99充值活动
export function apiNineDotNinetyNineAct(params) {
  return Request({
    url: '/api/v2/app/shop/activity/18/cfg',
    method: 'get',
    params,
  })
}

export function apiNineDotNinetyNineDraw() {
  return Request({
    url: '/api/v2/app/shop/activity/18/draw',
    method: 'post',
  })
}
